import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';

function CreateClient() {

    const [btnMessage, setBtnMessage] = useState("Crear cliente");
    const [user, setUser] = useState({})
    
    const [error, setError] = useState(false)
    const [sp, setShowPassword] = useState(false)
    const [emessage, setEmessage] = useState("")
    const hiddenFileInput = React.useRef(null);
    
    const [services, setServices] = useState([])
    const [service, setService] = useState({})

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');
    
    const [userRegisterStatus, setUserRegisterStatus] = useState(true)
    const [petRegisterStatus, setPetRegisterStatus] = useState(false)
    const [successStatus, setSuccessStatus] = useState(false)
    const [serviceRegisterStatus, setServiceRegisterStatus] = useState(false)
    const [dayRegisterStatus, setDayRegisterStatus] = useState(false)
    const [successOrderStatus, setSuccessOrderStatus] = useState(false)

    const [daySelected, setDaySelected] = useState({})
    const [agendaDays, setAgendaDays] = useState([])
    const [horaSelected, setHoraSelected] = useState("")

    const [clientInfo, setClientInfo] = useState({
        nombreUsuario: "",
        password: "prioritypet",
        email: "",
        uid: "",
    })

    const [petInfo, setPetInfo] = useState({
        mid: "",
        especie: "",
        raza: "",
        nombre: "",
    })

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    function handleChange(e) {
        setImg(URL.createObjectURL(e.target.files[0]));    
        setFile(e.target.files[0]);
    }

    const getServices = async(id) =>{
        let tipos = [];
        let tipos2 = [];
            
        await firebase.db.collection("Localidades").where("aliadoId", "==", id).get().then(val=>{
            val.docs.forEach(item=>{
            tipos.push(item.data())
            })
        })
    
        Promise.all(tipos.map(async (doc) => {
            
            firebase.db.collection("Localidades").doc(doc.localidadId).collection("Servicios").get().then(val=>{
            val.docs.forEach(item=>{
                let o1 = item.data()
                o1["nombreLocalidad"] = doc.nombreLocalidad
                tipos2.push(o1)
            })
            })
    
        }))
    
        setTimeout(() => {
            setServices(tipos2)
        }, 500);
  
    }

    async function getDaysFromService(s){
        let tipos = [];
        
        setService(s)
  
        await firebase.db.collection("Localidades").doc(s.localidadId)
        .collection("Servicios").doc(s.servicioId).collection("Agenda").orderBy("createdOn", "asc").get().then(val=>{
          val.docs.forEach(item=>{
            let d = moment(item.data().date.toDate())
            let today = moment()
            d.isSameOrAfter(today) && tipos.push(item.data())
          })
          setAgendaDays(tipos)
        })
  
      }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
            setUser(val)
            getServices(val.aliadoId)
        })
    }, [])

    return (

        <div className="main-content-container container-fluid px-4">

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                        <div className="ml-2 col row">
                          <p className="page-title bold"><Link className="page-title light" to="/clients">Clientes</Link> <span>Crear nuevo cliente</span></p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">

                <div className="col-lg-6 mx-auto my-0">

                    { userRegisterStatus && <>
                        <h3 className="mb-2">Crear nuevo cliente</h3>
                        <p className="color-primary light">Crea el cliente con solo los datos basicos para guardarlo dentro de tus clientes en la plataforma</p>
                        <div className="py-2">
                            <div className="form-group">
                                <input type="text" className="form-control" onChange={(e) => setClientInfo({...clientInfo, nombreUsuario: e.target.value})} placeholder="Nombre del cliente" value={clientInfo.nombreUsuario} />
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" onChange={(e) => setClientInfo({...clientInfo, email: e.target.value})} placeholder="Email" value={clientInfo.email} />
                            </div>
                            <div className="form-group d-none">
                                <div className="row align-items-center">
                                    <div className="col-md-11">
                                        <input type={sp ? "text" : "password"} className="form-control" onChange={(e) => setClientInfo({...clientInfo, password: e.target.value})} placeholder="Contraseña" value={clientInfo.password} />
                                    </div>
                                    <span onClick={()=>{setShowPassword(!sp)}} className="material-icons cursor-pointer mb-0">{sp ? "visibility_off" : "visibility" }</span>
                                </div>
                            </div>
                            <button onClick={()=>{ 
                                 (clientInfo.nombreUsuario !== "" && clientInfo.email !== "" && clientInfo.password !== "") && onRegister() 
                            }} className={`btn ${ clientInfo.nombreUsuario !== "" && clientInfo.email !== "" && clientInfo.password !== "" ? "btn-primary" : "btn-disabled"} btn-block`}>{btnMessage}</button>
                        </div> 
                    </>}
                    
                    { petRegisterStatus && <>
                        <h3 className="mb-2">Crear mascota del cliente</h3>
                        <p className="color-primary light">Crea la mascota del cliente con solo los datos basicos</p>
                        <div className="py-2">
                            <div className="form-group">
                                <input type="text" className="form-control" onChange={(e) => setPetInfo({...petInfo, especie: e.target.value})} placeholder="Especie de la mascota" value={petInfo.especie} />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" onChange={(e) => setPetInfo({...petInfo, raza: e.target.value})} placeholder="Raza de la mascota" value={petInfo.raza} />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" onChange={(e) => setPetInfo({...petInfo, nombre: e.target.value})} placeholder="Nombre de la mascota" value={petInfo.nombre} />
                            </div>
                            <button onClick={()=>{ 
                                petRegister()
                            }} className={`btn btn-primary btn-block`}>{btnMessage}</button>
                        </div> 
                    </>}
                    
                    { successStatus && <div className="container-creation-success">
                        <h3 className="mb-2">Cliente y mascota creados exitosamente</h3>
                        <span className="color-success material-icons">done</span>
                        <div className="row">
                            <div className="col-lg-6">
                                <Link to="/clients" className={`btn btn-outline-primary btn-block`}>Regresar a clientes</Link>
                            </div>
                            <div className="col-lg-6">
                                <button onClick={()=>{
                                    setServiceRegisterStatus(true); setUserRegisterStatus(false); setSuccessStatus(false)
                                }} className={`btn btn-success btn-block`}>Agendar cita</button>
                            </div>
                        </div>
                    </div>}
                    
                    { successOrderStatus && <div className="container-creation-success">
                        <h3 className="mb-2">Reservación creada exitosamente</h3>
                        <span className="color-success material-icons">done</span>
                        <div className="row">
                            <div className="col-lg-12">
                                <Link to="/clients" className={`btn btn-outline-primary btn-block`}>Regresar a clientes</Link>
                            </div>
                        </div>
                    </div>}
                        

                </div>

            </div>

            {/* Services and days */}
            { serviceRegisterStatus && <div className="container-services-creation-main">
                <h3>Selecciona el servicio</h3>
                <p className="color-primary light">Agrega las cuentas bancarias donde Priority Pet va a hacer los depositos de tus ventas</p>    
                <div className="container-services-creation my-4">
                    {services.map((s)=>{
                    return (
                        <div onClick={()=>{ service === s ? setService({}) : getDaysFromService(s) }} className={`cc-modal-card-2 mx-1 mb-3 cursor-pointer ${service === s ? "active" : "" }`} style={{backgroundImage: `url(${s.urlImagen})` }} key={s.servicioId}>
                            <div className="cc-modal-card-overlay">
                                <p className="mb-0 cc-modal-card-p">
                                {s.descripcion}
                                </p>
                                <p style={{width: "fit-content"}} className="pill-secondary rounded">{s.nombreLocalidad}</p>
                                <p className="mb-0 cc-modal-card-p-strong">
                                {s.titulo}
                                </p>
                            </div>
                        </div>
                    )
                    })}
                </div>
                <div className="row justify-content-spacebetween no-gutters">
                    <Link to="/clients" className={`btn btn-disabled`}>
                    Volver
                    </Link>
                    <button onClick={()=>{ setServiceRegisterStatus(false); setDayRegisterStatus(true) }} className={`btn btn-primary`}>
                    Continuar
                    </button>
                </div>
            </div> }
            
            { dayRegisterStatus && <div className="container-services-creation-main">
                <h3 className="mb-0">Selecciona el día y la hora</h3>
                <p className="color-primary light">Agrega las cuentas bancarias donde Priority Pet va a hacer los depositos de tus ventas</p>    
                
                <div style={{width: "inherit"}} className="my-4">
                  <div className="agenda-days-slider">
                    {agendaDays.map((d, i)=>{
                      return (
                        <p className={`${daySelected === d && "day-active"} mb-0`} onClick={()=>{ setDaySelected(d) }} key={i}>
                          {d.bloqueado && <> <i className="material-icons">lock</i> <br/> </>}
                          {d.fecha}
                        </p>
                      )
                    })}
                  </div>
                    
                  { (service.tipoAgenda === "Slots" && daySelected.horasDia !== undefined  ) && 
                    <div className="mt-3 slots-day"> 
                      {
                        daySelected.horasDia.map((h, i)=> <div onClick={()=>{ setHoraSelected(h) }} className={`pill-secondary-2 ${horaSelected === h && "active"}`} key={i}>{h}</div>)
                      }
                    </div>
                  }
                </div>
                
                <div className="row justify-content-spacebetween no-gutters">
                    <button onClick={()=>{ setServiceRegisterStatus(true); setDayRegisterStatus(false); setDaySelected({}) }} className={`btn btn-disabled`}>
                    Volver
                    </button>
                    <button onClick={()=>{
                        createReservation()
                    }} className={`btn btn-primary`}>
                    Continuar
                    </button>
                </div>
            </div> }

            {/* End Services and days */}

          </div>
    )

    async function onRegister() {
        setBtnMessage("Cargando...")
        let id = Date.now().toString()
        try {
            firebase.createClient(user.aliadoId, user.clientes, clientInfo.email, clientInfo.password, clientInfo.nombreUsuario, "https://firebasestorage.googleapis.com/v0/b/priority-pet.appspot.com/o/947277.png?alt=media&token=6ecdf07c-98ad-4de8-aab3-f82ca64f7f99").then((uid)=>{
                setClientInfo({...clientInfo, uid: uid})
                axios.get(`https://us-central1-priority-pet.cloudfunctions.net/sendInvitationEmail?dest=${clientInfo.email}&aliado=${user.nombre}&username=${clientInfo.nombreUsuario}`)
            })
            setBtnMessage("Crear mascota")
            setUserRegisterStatus(false)
            setPetRegisterStatus(true)

        } catch(e) {
            setBtnMessage("Crear cliente")
            switch(e.message) {
                case "The email address is badly formatted.":
                    setError(true)
                    setTimeout(() => {
      				  setError(false)
      				}, 4000);
                    setEmessage("Debes ingresar un email correcto");
                break;
                case "The email address is already in use by another account.":
                    setError(true)
                    setTimeout(() => {
      				  setError(false)
      				}, 4000);
                    setEmessage("Tu cuenta ya está registrada con nosotros, si deseas hacer algún cambio o una compra descarga nuestra aplicación.");
                break;
                case "Password should be at least 6 characters":
                    setError(true)
                    setTimeout(() => {
      				  setError(false)
      				}, 4000);
                    setEmessage("La contraseña debe ser mayor a 5 caracteres");
                break;
                default:
                    setError(true)
                    setTimeout(() => {
      				  setError(false)
      				}, 4000);
                    setEmessage(e.message);
                break;
            }
        }
    }

    async function petRegister() {
        const id = moment().valueOf().toString()
        try {
            await firebase.db.collection("Mascotas").doc(id).set({
                mid: id,
                uid: clientInfo.uid,
                especie: petInfo.especie,
                raza: petInfo.raza,
                nombre: petInfo.nombre,
                acerca: "",
                fechanac: "",
                petthumbnailUrl: "https://firebasestorage.googleapis.com/v0/b/priority-pet.appspot.com/o/btn_mejora.png?alt=media&token=597f0dd1-8ed5-445b-9d6d-c33aa81805dc",
                sexo: "",
            }).then((val)=>{
                setPetInfo({...petInfo, mid: id})
            })
            // setUserRegisterStatus(false)
            // setPetRegisterStatus(true)

        } catch(e) {
            alert(e)
        }
        setPetRegisterStatus(false)
        setSuccessStatus(true)
    }

    
    async function createReservation(){
      try{
        const oid = moment().valueOf().toString()
        // console.log(client)
        await firebase.db.collection("Ordenes").doc(oid).set({
          uid: clientInfo.uid,
          localidadId: service.localidadId,
          pais: user.pais,
          status: "Por confirmar",
          statusCita: "Por confirmar",
          nombreComercial: user.nombreComercial,
          titulo: service.titulo,
          oid: oid,
          aliadoId: user.aliadoId,
          servicioid: service.servicioId,
          date: daySelected.date,
          hora: horaSelected,
          fecha: daySelected.fecha,
          precio: service.precio,
          mid: petInfo.mid,
          user: clientInfo.nombreUsuario,
          tipoOrden: service.titulo === "Videoconsulta" ? "Videoconsulta" : "Servicio",
          videoId: "q2d_21VC",
          createdOn: moment().toDate()
        }).then((v)=>{
            firebase.db.collection("Ordenes").doc(oid).collection("Items").doc(service.servicioId).set({
              aliadoId: user.aliadoId,
              date: daySelected.date,
              delivery: service.delivery,
              domicilio: service.domicilio,
              fecha: daySelected.fecha,
              hora: horaSelected,
              mid: petInfo.mid,
              nombre: petInfo.nombre,
              nombreComercial: user.nombreComercial,
              oid: oid,
              petthumbnailUrl: "",
              precio: service.precio,
              servicioid: service.servicioId,
              tieneDelivery: false,
              tieneDomicilio: false,
              titulo: service.titulo,
              uid: clientInfo.uid,
            })
        })
        setDayRegisterStatus(false)
        setSuccessOrderStatus(true)

      }catch(e){
        console.log("Error: " + e)
      }
    }

}

export default CreateClient